import {LitElement, css, html} from "lit";
import {mix} from "mixwith";
import StateMixin from "./Mixins/StateMixin.js";

export class AuiButton extends mix(LitElement).with(StateMixin) {

	firstUpdated(changedProperties) {
		super.firstUpdated(changedProperties);
		this.setAttribute("tabindex", 0);
	}

	static get styles() {
		return css`
			:host {
				background: var(--primary-color);
				position: relative;
				display: inline-block;
				margin: 2px 0;
				padding: 8px 16px;
				border-radius: 3px;
				color: #FFF;
				cursor: pointer;
				outline: none;
			}
			
			/* Disabled State */
			:host([disabled]) { opacity: 0.5; }
			
			/* Focus State */
			:host([focused]):after {
				content: '';
				display: block;
				position: absolute;
				top: -3px;
				bottom: -3px;
				left: -3px;
				right: -3px;
				border: 1px dashed var(--primary-color);
				border-radius: 3px;
				pointer-events: none;
			}
		`;
	}

	render() {
		return html`<slot></slot>`;
	}

}

export default AuiButton;

customElements.define("aui-button", AuiButton);